import { usePublishedConversationTemplates } from "@samklang/content";
import { listPublishedConversationTemplates } from "@samklang/database";
import { ConversationTemplateSchema } from "@samklang/schemas";
import { z } from "zod";
import { supabase } from "./supabase";

const cacheKey = "samklang-public-content-v1";
const CacheSchema = z.array(ConversationTemplateSchema);

export async function hydratePublishedContent(): Promise<void> {
  try {
    const cached = window.localStorage.getItem(cacheKey);
    if (cached) usePublishedConversationTemplates(CacheSchema.parse(JSON.parse(cached)));
  } catch {
    window.localStorage.removeItem(cacheKey);
  }
  if (!supabase) return;
  try {
    const published = await listPublishedConversationTemplates(supabase);
    if (published.length === 0) return;
    usePublishedConversationTemplates(published);
    window.localStorage.setItem(cacheKey, JSON.stringify(published));
  } catch {
    // Det validerade, paketerade innehållet är alltid säker offline-reserv.
  }
}
